module.exports = __webpack_public_path__ + "img/blog.af516436.png";